import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import type { RirekishoPhoto } from '@src/api/core/api-types';

const initialState: RirekishoPhoto = {
  photoPath: '',
};

const rirekishoPhotoSlice = createSlice({
  name: 'rirekishoPhoto',
  initialState,
  reducers: {
    updateRirekishoPhoto: (state, action: PayloadAction<Partial<RirekishoPhoto>>) => {
      return { ...state, ...action.payload };
    },
    resetRirekishoPhoto: () => initialState,
  },
});

export const { updateRirekishoPhoto } = rirekishoPhotoSlice.actions;

export default rirekishoPhotoSlice.reducer;
